import './BannerSection.css';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import api from '../../../api';
import NotFound from '../../Pages/NotFound/NotFound';
import DynamicBreadcrumb from '../../Pages/include/DynamicBreadcrumb';

const BannerSection = () => {
  const { miniSlug, slug } = useParams();
  const [pageConfig, setPageConfig] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false
  };

  useEffect(() => {
    const fetchCollegeData = async () => {
      try {
        setLoading(true);
        setError(false);
        setNotFound(false);

        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/${miniSlug}/${slug}`);
        const data = response.data;

        const bannerData = data.banner || {};
        const buttons = bannerData.buttons || [];

        setPageConfig({
          heading: data.name || bannerData.heading || 'Chettinad College',
          buttons,
          bannerImages: bannerData.images || []
        });
      } catch (error) {
        console.error('Error fetching college data:', error);
        setError(true);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    fetchCollegeData();
  }, [miniSlug, slug]);

  if (loading) return null;
  if (notFound || !pageConfig || pageConfig.bannerImages.length === 0) return <NotFound />;

  if (error) {
    return null;
  }

  return (
    <section className="breadcrump_section">
      <Slider {...sliderSettings} className="banner-slider">
        {pageConfig.bannerImages.map((img, index) => (
          <div key={index} className="banner-slide">
            <img 
              src={process.env.REACT_APP_API_URL + '/public' + img} 
              alt={`Banner ${index + 1}`} 
            />
          </div>
        ))}
      </Slider>
        <DynamicBreadcrumb />

      <div className="breadcrump-wrapper">
        <h1 className="breadcrump-heading">{pageConfig.heading}</h1>

        {pageConfig.buttons.length > 0 && (
          <div className="d-flex flex-wrap gap-3 mt-3 justify-content-center">
            {pageConfig.buttons.map((btn, idx) => (
              <a
                key={idx}
                href={btn.link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn apply-new-btn"
                dangerouslySetInnerHTML={{ __html: btn.text }}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BannerSection;
